// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__mxRVo","sk-bouncedelay":"Spinner_sk-bouncedelay__VwGU0","Bounce1":"Spinner_Bounce1__SWHAG","Bounce2":"Spinner_Bounce2__3bNbN"};